import { O, pipe } from '@packages/prelude'

export const configure = (window: Window) => (config: ReadonlyArray<unknown>) => {
  pipe(
    window._paq,
    O.fromNullable,
    O.map(_paq => _paq.push(config))
  )
}
